import { useRef, useState } from 'react';
import { Box, LinearProgress, Typography, Popover, List, ListItem } from '@mui/material'
import { Error, CheckCircle } from '@mui/icons-material';
import { dummy_popover_list_data } from './mock';
import { colors, typography } from './styles/globals';
import _ from "lodash"

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        background: colors.cardBackground,
        borderRadius: "16px",
        padding: "16px", // Increased from 8px to 16px
        height: "90px",
        minWidth: "170px",
        flex: 1
    },
    titleBox: {
        width: "100%"
    },
    title: {
        fontWeight: typography.fontWeights.regular,
        fontSize: typography.fontSizes.small,
        mb: "1px",
        color: colors.lightGrey
    },
    progressBar: {
        borderRadius: "6px",
        height: "3px"
    },
    bottomBox: {
        display: "flex",
        gap: "30px",
        justifyContent: "space-between",
        width: "100%"
    },
    bottomText: {
        fontWeight: typography.fontWeights.semibold,
        fontSize: typography.fontSizes.h4,
        color: colors.white,
        display: "inline"
    },
    viewDetailsButton: {
        padding: 0,
        minWidth: 'auto'
    },
    viewDetailsText: {
        color: colors.white,
        fontSize: typography.fontSizes.small,
        '&:hover': { textDecoration: 'underline', fontWeight: typography.fontWeights.bold, backgroundColor: "none" },
        whiteSpace: 'nowrap',
        textTransform: 'none'
    },
    popoverBox: {
        maxHeight: 200,
        width: 300,
        overflowY: 'auto',
        backgroundColor: colors.white,
        color: 'black',
        padding: "8px" // Added padding
    },
    popoverList: {
        px: 2 // Increased from 1 to 2
    },
    popoverItem: {
        display: "flex",
        alignItems: "center",
        padding: "4px" // Added padding
    },
    popoverListItem: {
        px: 1 // Increased from 0.5 to 1
    }
}

const BaseDetailCard = ({
    title,
    showProgress = false,
    progressValue = 0,
    bottomLeftContent,
}) => {
    const [popoverOpen, setPopoverOpen] = useState(false)
    const popoverRef = useRef(null)

    const onHandleViewDetails = (e) => {
        popoverRef.current = e.currentTarget
        setPopoverOpen(prevOpen => !prevOpen)
    }

    return (
        <Box sx={styles.container}>
            <Box sx={styles.titleBox}>
                <Typography
                    sx={styles.title}>
                    {title}
                </Typography>
                {showProgress && (
                    <LinearProgress
                        variant="determinate"
                        value={progressValue}
                        sx={styles.progressBar}
                    />
                )}
            </Box>
            <Box sx={styles.bottomBox}>
                <Typography
                    sx={styles.bottomText}
                >
                    {bottomLeftContent}
                </Typography>
                {/* <Button sx={styles.viewDetailsButton} onClick={onHandleViewDetails}>
                    <Typography sx={styles.viewDetailsText}>
                        View Details
                    </Typography>
                    {popoverOpen ? <KeyboardArrowUpIcon sx={{ color: colors.grey }} /> : <KeyboardArrowDownIcon sx={{ color: colors.grey }} />}
                </Button> */}
            </Box>
            <Popover
                open={popoverOpen}
                anchorEl={popoverRef.current}
                onClose={onHandleViewDetails}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box sx={styles.popoverBox}>
                    <List sx={styles.popoverList}>
                        {_.map(dummy_popover_list_data, (item) => (
                            <Box key={item.id} sx={styles.popoverItem}>
                                {item.hasError ? <Error color="error" /> : <CheckCircle color="success" />}
                                <ListItem sx={styles.popoverListItem}>{item.id}</ListItem>
                            </Box>
                        ))}
                    </List>
                </Box>
            </Popover>
        </Box>
    )
}

export default BaseDetailCard